export const tenantAvailableUnitsHeaders = [
  {
    text: "Type Name",
    value: "width"
  },
  {
    text: "Square Footage",
    value: "area"
  },
  {
    text: "Current Promotion",
    value: "promotion_text"
  },
  {
    text: "Rate",
    value: "rate"
  },
  {
    text: "Unit Type",
    value: "product_type"
  },
  {
    text: "Available",
    value: "total_vacant",
    width: "100px"
  },
  {
    text: "Actions...",
    sortable: false,
    value: "actions"
  }
];
